import { Link, useParams, useNavigate } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "./../../components/panel/panel.jsx";
import StaffTabBar from "./staffTabBar.js";
import { useState } from "react";
import showErrorToast, {
  showSuccessToast,
} from "../../components/CustomComponents/toast/toast.js";
import axiosInstance from "../../config/axiosApi/axiosApi.jsx";
import APIs from "../../Constants/apis.js";
import FormInput from "../../components/CustomComponents/Input/formInput.jsx";
import { useSelector } from "react-redux";
import Preloader from "../../components/CustomComponents/preLoad/preLoader.js";

const UpdatePassword = () => {
  const CompID = useSelector((state) => state.auth.user)?.userData?.compID;
  const { UserName } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmNewPassword) {
      showErrorToast("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.post(APIs.UPDATE_PASSWORD, {
        UserName,
        Password: newPassword,
        ConfirmPassword: newPassword
      },{
        params: {
          CompID
        },
      });
      if (response.data.status) {
        setLoading(false);
        showSuccessToast("Password updated successfully.");
        navigate("/staff/manageStaff");
      } else {
        showErrorToast(response.data.message);
      }
    } catch (err) {
      setLoading(false);
      showErrorToast("Something went wrong.");
      console.log(err);
    }
    finally { 
      setLoading(false);
    }
  };

  return (
    <div>
    {loading && <Preloader />}
  
      <div className="d-flex align-items-center mb-2 mt-2">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/staff/manageStaff">Manage Staff</Link>
            </li>
            <li className="breadcrumb-item active">Update Password</li>
          </ol>
          <h1 className="page-header mb-0">Update Password ({UserName})</h1>
        </div>
        <div className="ms-auto">
          <button
            onClick={handleSubmit}
            className="btn btn-success btn-rounded px-4 rounded-pill"
          >
            <i className="fa fa-save fa-lg me-2 ms-n2 text-success-900"></i>
            Submit
          </button>
        </div>
      </div>
      <div className="card border-0">
        <StaffTabBar
          activeTab="updatePassword"
          useTab="false"
          UserName={UserName}
        />
        <Panel className="m-3">
          <PanelHeader>General</PanelHeader>
          <PanelBody>
            <div className="row mb-3">
              <div className="col-6">
                <FormInput
                  label="New Password"
                  placeHolder="Enter New Password"
                  type="password"
                  value={newPassword}
                  onchange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div className="col-6">
                <FormInput
                  label="Confirm New Password"
                  placeHolder="Confirm New Password"
                  type="password"
                  value={confirmNewPassword}
                  onchange={(e) => setConfirmNewPassword(e.target.value)}
                />
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    </div>
  );
};

export default UpdatePassword;